import React from 'react';
import Img from 'graphcms-image';

import Paragraph from './renderers/Paragraph';
import Heading from './renderers/Heading';
import CardCTA from './CardCTA';
import CardLink from './CardLink';
import Pill from './Pill';

const ResourceCard = ({
  coverImage,
  externalUrl,
  friendlyStartDate,
  linkPath,
  id,
  starts,
  truncatedSubTitle,
  title,
  type,
}) => {
  const isUpcoming = new Date(starts) > new Date();

  const ctaText = type === 'WEBINAR' && isUpcoming ? 'Register' : 'Download';

  return (
    <article className="flex flex-1" key={id}>
      <CardLink externalUrl={externalUrl} linkPath={linkPath}>
        {coverImage && (
          <div className="mb-2">
            <Img
              className="rounded-lg"
              image={coverImage}
              maxWidth={560}
              transforms={['quality=value:75']}
              withWebp
            />
          </div>
        )}
        <div className="-mt-6">
          <Heading children={title} level={4} className="mb-2" />
        </div>
        <div className="-mx-1 -my-1 flex flex-wrap">
          <Pill label={type} />
        </div>
        <Paragraph className="flex-grow">{truncatedSubTitle}</Paragraph>
        <div className="flex items-center justify-between">
          <CardCTA label={ctaText} />
          {type === 'WEBINAR' && (
            <div className="flex items-center mr-4">
              {isUpcoming && (
                <p className="text-cornflower">{friendlyStartDate}</p>
              )}
            </div>
          )}
        </div>
      </CardLink>
    </article>
  );
};

export default ResourceCard;
